import { Navigate, Routes, Route } from "react-router";
import Organizations from '../pages/admin/Organizations';
import O365Licenses from '../pages/admin/O365/O365Licenses';
import ESET from '../pages/admin/ESET/ESET';
import O365Users from '../pages/admin/O365/O365Users';
import O365Dashboard from '../pages/admin/O365/O365Dashboard';
import EsetLicenses from '../pages/admin/ESET/EsetLicenses';
import { Box } from '@mui/material';
import VBO from '../pages/admin/VBO/VBO';
import VBO365Licenses from '../pages/admin/VBO/VBO365Licenses';
import VBO365Users from '../pages/admin/VBO/VBO365Users';
import EsetDevices from '../pages/admin/ESET/EsetDevices';
import SignIn from '../pages/admin/Authentification/SignIn';
import HistoryLog from '../pages/admin/HistoryLog';
import Domain from '../pages/admin/Domain';
import Centreon from '../pages/admin/CENTREON/Centreon';
import VcspPage from '../pages/admin/VCSP/VcspPage';
import Contrats from '../pages/admin/Contrats';
import Quotes from '../pages/admin/Administratif/Quotes';
import Tickets from '../pages/admin/Tickets/Tickets';
import NotFound from '../pages/admin/NotFound';
import ContratDetails from '../pages/admin/ContratDetails';
import Signitic from '../pages/admin/Signitic/Signitic';
import QuoteSign from '../pages/admin/Administratif/QuoteSign';
import ContratMatrix from '../pages/admin/ContratMatrix';
import OAuthSuccess from '../pages/admin/OAuthSuccess';
import ImportMain from '../pages/admin/Import/ImportMain';
import Home from '../pages/admin/Home';
import Users from "../pages/admin/Users";
import Products from "../pages/admin/Products";
import Mc3Products from "../pages/admin/MC3Cloud/MC3Product";
import TimeEntryERM from "../pages/admin/Tickets/TimeEntryERM";
import IK from "../pages/admin/Tickets/IK";
import ContratListePage from "../pages/admin/Administratif/Contrat/V2/ContratListePage";
import Contrat from "../pages/admin/Administratif/Contrat/Contrat";
// import ContratListePage from "../pages/admin/Administratif/Contrat/ContratListePlage";
import ContratMatrixPage from "../pages/admin/Administratif/Contrat/V2/ContratMatrixPage";
import RapportAnnuelPage from "../pages/admin/Administratif/Contrat/V2/RapportAnnuelPage";
import RapportMensuelPage from "../pages/admin/Administratif/Contrat/V2/RapportMensuelPage";
import ContratDashboard from "../pages/admin/Administratif/Contrat/V2/ContratDashboard";
import IKGlobal from "../pages/admin/Tickets/IKGlobal";
import ReportADVPage from "../pages/admin/Administratif/ReportADVPage";
import FacturesPage from "../pages/admin/Administratif/Factures";
import StaffPortfolioPage from "../pages/admin/StaffPortfolioPage";
import OrganizationSitesPage from "../pages/admin/OrganizationSitesPage";
import LevelDevicesPage from "../pages/admin/Level/LevelDevicesPage";
import SettingsPage from "../pages/admin/Settings/SettingsPage";
import AgentsPage from "../pages/admin/AgentsPage";
import ClientActivityJournal from "../pages/client/ClientActivityJournal";
// import ContratMensuelPage from "../pages/admin/Administratif/Contrat/ContratMensuelPage";
// import ContratAnnuelPage from "../pages/admin/Administratif/Contrat/ContratAnnuelPage";

function MainViewAdmin({ data }) {

  return (
    <Box sx={{ width: '100%',  }}>
    <Routes>
        <Route path="organizations">
          <Route index element={<Organizations />} />
          <Route path="users" element={<Users />} />
          <Route path="sites" element={<OrganizationSitesPage />} />
          <Route path="activity-journal" element={<ClientActivityJournal />} />
          <Route path="portfolio" element={<StaffPortfolioPage />} />
        </Route>
        
        <Route path="home" element={<Home />} />  
        <Route path="products" element={<Products />} />  
        <Route path="reports" element={<ReportADVPage />} />  
        <Route path="mc3cloud/products" element={<Mc3Products />} />  

        <Route path="o365" element={<O365Dashboard />} />  
        <Route path="o365/licenses" element={<O365Licenses />} />  
        <Route path="o365/users" element={<O365Users />} /> 

        <Route path="eset" element={<ESET />} />  
        <Route path="eset/licenses" element={<EsetLicenses />} />  
        <Route path="eset/devices" element={<EsetDevices />} />  

        <Route path="history" element={<HistoryLog />} /> 

        <Route path="vbo365" element={<VBO />} />  
        <Route path="vbo365/licenses" element={<VBO365Licenses />} />  
        <Route path="vbo365/users" element={<VBO365Users />} />  

        <Route path="domain" element={<Domain />} />  
        <Route path="import" element={<ImportMain />} />  
        <Route path="tickets" element={<Tickets />} />  
        <Route path="tickets/timeEntry" element={<TimeEntryERM />} />  
        <Route path="tickets/myik" element={<IK />} />  
        <Route path="tickets/ik" element={<IKGlobal />} />  

        <Route path="centreon" element={<Centreon />} />  
        <Route path="vcsp" element={<Navigate to="vcsp/repos" replace />} />
        <Route path="vcsp/repos" element={<VcspPage view="repos" />} />
        <Route path="vcsp/jobs" element={<VcspPage view="jobs" />} />  
        <Route path="agents" element={<AgentsPage />} />
        <Route path="level/devices" element={<LevelDevicesPage />} />  
        {/* <Route path="contrats" element={<Contrats  />} />   */}
        {/* <Route path="contrats/:id" element={<ContratDetails  />} />   */}
        <Route path="easyredmine" element={<Tickets  />} />  

        <Route path="auth" element={<SignIn />} />  
        <Route path="quotes" element={<Quotes />} />  
        <Route path="*" element={<NotFound />} />

        <Route path="quotes" >
          <Route index element={<Quotes />} />
          {/* <Route path=":id" element={<Quotes />} />   */}
          <Route path="form" element={<QuoteSign />} />  
        </Route>



         <Route path="contrats">
          <Route index element={<ContratDashboard />} />
          <Route path="matrix" element={<ContratMatrixPage />} /> 
          <Route path="list" element={<ContratListePage />} /> 
          <Route path="annual" element={<RapportAnnuelPage />} />
          <Route path="monthly" element={<RapportMensuelPage />} />
          {/* <Route path="matrix" element={<ContratMatrixPage />} />  */}
          {/* <Route path="monthly" element={<ContratMensuelPage />} />
          <Route path=":id" element={<ContratDetails />} /> */}
          
        </Route>

        <Route path="signitic" element={<Signitic />} />
        <Route path="factures" element={<FacturesPage />} />
        <Route path="settings">
          <Route index element={<Navigate to="general" replace />} />
          <Route path="general" element={<SettingsPage section="general" />} />
          <Route path="signitic" element={<SettingsPage section="signitic" />} />
          <Route path="eset" element={<SettingsPage section="eset" />} />
          <Route path="level" element={<SettingsPage section="level" />} />
          <Route path="ovh" element={<SettingsPage section="ovh" />} />
          <Route path="centreon" element={<SettingsPage section="centreon" />} />
          <Route path="vcsp" element={<SettingsPage section="vcsp" />} />
          <Route path="cron" element={<SettingsPage section="cron" />} />
        </Route>

        {/* <Route path="eset/devices" element={<ESETDevices />} />   */}
    </Routes>
    </Box>
  )
}

export default MainViewAdmin
